// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/model/v1/model.proto" (package "agency.model.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Duration } from "../../../google/protobuf/duration";
import { Struct } from "../../../google/protobuf/struct";
/**
 * ProviderCompat defines cross-provider message format compatibility.
 *
 * @generated from protobuf message agency.model.v1.ProviderCompat
 */
export interface ProviderCompat {
    /**
     * supports_thinking indicates if the model supports extended thinking.
     *
     * @generated from protobuf field: bool supports_thinking = 1
     */
    supportsThinking: boolean;
    /**
     * supports_tool_calls indicates if the model supports native tool calling.
     *
     * @generated from protobuf field: bool supports_tool_calls = 2
     */
    supportsToolCalls: boolean;
    /**
     * supports_streaming indicates if the model supports streaming responses.
     *
     * @generated from protobuf field: bool supports_streaming = 3
     */
    supportsStreaming: boolean;
    /**
     * supports_vision indicates if the model can process images.
     *
     * @generated from protobuf field: bool supports_vision = 4
     */
    supportsVision: boolean;
    /**
     * supports_audio indicates if the model can process audio.
     *
     * @generated from protobuf field: bool supports_audio = 5
     */
    supportsAudio: boolean;
    /**
     * supports_video indicates if the model can process video.
     *
     * @generated from protobuf field: bool supports_video = 6
     */
    supportsVideo: boolean;
    /**
     * max_tool_call_id_length is the maximum tool call ID length (0 = unlimited).
     *
     * @generated from protobuf field: int32 max_tool_call_id_length = 7
     */
    maxToolCallIdLength: number;
    /**
     * requires_tool_choice indicates if tool_choice must be specified when tools are present.
     *
     * @generated from protobuf field: bool requires_tool_choice = 8
     */
    requiresToolChoice: boolean;
    /**
     * thinking_block_tag is the XML-style tag for thinking content (e.g., "<thinking>").
     *
     * @generated from protobuf field: string thinking_block_tag = 9
     */
    thinkingBlockTag: string;
    /**
     * supports_system_prompt indicates if separate system prompts are supported.
     *
     * @generated from protobuf field: bool supports_system_prompt = 10
     */
    supportsSystemPrompt: boolean;
    /**
     * requires_alternating_roles indicates if messages must alternate user/assistant.
     *
     * @generated from protobuf field: bool requires_alternating_roles = 11
     */
    requiresAlternatingRoles: boolean;
}
/**
 * ProviderCapabilities defines provider-specific features and limits.
 *
 * @generated from protobuf message agency.model.v1.ProviderCapabilities
 */
export interface ProviderCapabilities {
    /**
     * max_context_tokens is the maximum context window size.
     *
     * @generated from protobuf field: int32 max_context_tokens = 1
     */
    maxContextTokens: number;
    /**
     * max_output_tokens is the maximum response length.
     *
     * @generated from protobuf field: int32 max_output_tokens = 2
     */
    maxOutputTokens: number;
    /**
     * max_tools_per_request is the maximum tools allowed per request.
     *
     * @generated from protobuf field: int32 max_tools_per_request = 3
     */
    maxToolsPerRequest: number;
    /**
     * supports_parallel_tool_calls indicates if multiple tools can be called simultaneously.
     *
     * @generated from protobuf field: bool supports_parallel_tool_calls = 4
     */
    supportsParallelToolCalls: boolean;
    /**
     * rate_limit_rpm is the requests per minute limit (0 = unlimited).
     *
     * @generated from protobuf field: int32 rate_limit_rpm = 5
     */
    rateLimitRpm: number;
    /**
     * rate_limit_tpm is the tokens per minute limit (0 = unlimited).
     *
     * @generated from protobuf field: int32 rate_limit_tpm = 6
     */
    rateLimitTpm: number;
    /**
     * cost_per_million_input_tokens is the input token pricing.
     *
     * @generated from protobuf field: float cost_per_million_input_tokens = 7
     */
    costPerMillionInputTokens: number;
    /**
     * cost_per_million_output_tokens is the output token pricing.
     *
     * @generated from protobuf field: float cost_per_million_output_tokens = 8
     */
    costPerMillionOutputTokens: number;
    /**
     * default_temperature is the default temperature setting.
     *
     * @generated from protobuf field: float default_temperature = 9
     */
    defaultTemperature: number;
    /**
     * supports_json_mode indicates if JSON output mode is supported.
     *
     * @generated from protobuf field: bool supports_json_mode = 10
     */
    supportsJsonMode: boolean;
    /**
     * supports_function_calling indicates if function calling is supported (legacy OpenAI).
     *
     * @generated from protobuf field: bool supports_function_calling = 11
     */
    supportsFunctionCalling: boolean;
    /**
     * supports_session_caching indicates if prompt caching is supported.
     *
     * @generated from protobuf field: bool supports_session_caching = 12
     */
    supportsSessionCaching: boolean;
    /**
     * supports_images indicates if image inputs are supported.
     *
     * @generated from protobuf field: bool supports_images = 13
     */
    supportsImages: boolean;
    /**
     * supports_tools indicates if tool/function calling is supported.
     *
     * @generated from protobuf field: bool supports_tools = 14
     */
    supportsTools: boolean;
    /**
     * supports_streaming indicates if streaming responses are supported.
     *
     * @generated from protobuf field: bool supports_streaming = 15
     */
    supportsStreaming: boolean;
    /**
     * supports_thinking indicates if extended thinking is supported.
     *
     * @generated from protobuf field: bool supports_thinking = 16
     */
    supportsThinking: boolean;
    /**
     * max_images_per_request is the maximum images allowed per request.
     *
     * @generated from protobuf field: int32 max_images_per_request = 17
     */
    maxImagesPerRequest: number;
}
/**
 * ModelConfig defines a specific model configuration.
 *
 * @generated from protobuf message agency.model.v1.ModelConfig
 */
export interface ModelConfig {
    /**
     * model_id uniquely identifies this model configuration.
     *
     * @generated from protobuf field: string model_id = 1
     */
    modelId: string;
    /**
     * provider is the LLM provider.
     *
     * @generated from protobuf field: agency.model.v1.ModelProvider provider = 2
     */
    provider: ModelProvider;
    /**
     * provider_model_id is the provider's model identifier (e.g., "gpt-4", "claude-3-opus").
     *
     * @generated from protobuf field: string provider_model_id = 3
     */
    providerModelId: string;
    /**
     * display_name is the human-readable model name.
     *
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * compat defines compatibility features.
     *
     * @generated from protobuf field: agency.model.v1.ProviderCompat compat = 5
     */
    compat?: ProviderCompat;
    /**
     * capabilities defines provider limits and features.
     *
     * @generated from protobuf field: agency.model.v1.ProviderCapabilities capabilities = 6
     */
    capabilities?: ProviderCapabilities;
    /**
     * endpoint_url is the API endpoint (for self-hosted or custom providers).
     *
     * @generated from protobuf field: string endpoint_url = 7
     */
    endpointUrl: string;
    /**
     * api_version is the API version string (provider-specific).
     *
     * @generated from protobuf field: string api_version = 8
     */
    apiVersion: string;
    /**
     * default_params are default request parameters.
     *
     * @generated from protobuf field: map<string, string> default_params = 9
     */
    defaultParams: {
        [key: string]: string;
    };
    /**
     * tags are categorization labels for selection.
     *
     * @generated from protobuf field: repeated string tags = 10
     */
    tags: string[];
    /**
     * priority is the selection priority (higher = preferred).
     *
     * @generated from protobuf field: int32 priority = 11
     */
    priority: number;
    /**
     * enabled indicates if this model is available for use.
     *
     * @generated from protobuf field: bool enabled = 12
     */
    enabled: boolean;
    /**
     * health_check_url is the endpoint for health checks (optional).
     *
     * @generated from protobuf field: string health_check_url = 13
     */
    healthCheckUrl: string;
    /**
     * timeout_seconds is the request timeout.
     *
     * @generated from protobuf field: int32 timeout_seconds = 14
     */
    timeoutSeconds: number;
    /**
     * retry_config defines retry behavior.
     *
     * @generated from protobuf field: agency.model.v1.RetryConfig retry_config = 15
     */
    retryConfig?: RetryConfig;
    /**
     * fallback_chain defines fallback models (primary→secondary→tertiary).
     *
     * @generated from protobuf field: agency.model.v1.ModelFallbackChain fallback_chain = 16
     */
    fallbackChain?: ModelFallbackChain;
    /**
     * selection_strategy defines how this model is selected.
     *
     * @generated from protobuf field: agency.model.v1.ModelSelectionStrategy selection_strategy = 17
     */
    selectionStrategy?: ModelSelectionStrategy;
    /**
     * extra_body is merged verbatim (JSON types preserved) into the top level of
     * the provider request body. Keys must not collide with adapter-owned body
     * keys or forwarded default_params keys.
     *
     * @generated from protobuf field: google.protobuf.Struct extra_body = 19
     */
    extraBody?: Struct;
    /**
     * background_poll_interval is the poll cadence for background-mode adapters.
     * Required iff the adapter runs in background mode; rejected by adapters otherwise.
     *
     * @generated from protobuf field: google.protobuf.Duration background_poll_interval = 20
     */
    backgroundPollInterval?: Duration;
}
/**
 * RetryConfig defines retry behavior for model requests.
 *
 * @generated from protobuf message agency.model.v1.RetryConfig
 */
export interface RetryConfig {
    /**
     * max_retries is the maximum retry attempts.
     *
     * @generated from protobuf field: int32 max_retries = 1
     */
    maxRetries: number;
    /**
     * initial_backoff_ms is the initial backoff delay in milliseconds.
     *
     * @generated from protobuf field: int32 initial_backoff_ms = 2
     */
    initialBackoffMs: number;
    /**
     * max_backoff_ms is the maximum backoff delay in milliseconds.
     *
     * @generated from protobuf field: int32 max_backoff_ms = 3
     */
    maxBackoffMs: number;
    /**
     * backoff_multiplier is the exponential backoff multiplier.
     *
     * @generated from protobuf field: float backoff_multiplier = 4
     */
    backoffMultiplier: number;
    /**
     * retryable_status_codes are HTTP status codes that trigger retries.
     *
     * @generated from protobuf field: repeated int32 retryable_status_codes = 5
     */
    retryableStatusCodes: number[];
}
/**
 * ModelSelectionRequest requests model selection based on criteria.
 *
 * @generated from protobuf message agency.model.v1.ModelSelectionRequest
 */
export interface ModelSelectionRequest {
    /**
     * required_capabilities are must-have features.
     *
     * @generated from protobuf field: agency.model.v1.ProviderCompat required_capabilities = 1
     */
    requiredCapabilities?: ProviderCompat;
    /**
     * preferred_providers are preferred provider priorities.
     *
     * @generated from protobuf field: repeated agency.model.v1.ModelProvider preferred_providers = 2
     */
    preferredProviders: ModelProvider[];
    /**
     * min_context_tokens is the minimum required context window.
     *
     * @generated from protobuf field: int32 min_context_tokens = 3
     */
    minContextTokens: number;
    /**
     * max_cost_per_million_tokens is the maximum acceptable cost.
     *
     * @generated from protobuf field: float max_cost_per_million_tokens = 4
     */
    maxCostPerMillionTokens: number;
    /**
     * required_tags are tags that must be present.
     *
     * @generated from protobuf field: repeated string required_tags = 5
     */
    requiredTags: string[];
    /**
     * exclude_model_ids are models to exclude from selection.
     *
     * @generated from protobuf field: repeated string exclude_model_ids = 6
     */
    excludeModelIds: string[];
}
/**
 * ModelSelectionResponse returns the selected model.
 *
 * @generated from protobuf message agency.model.v1.ModelSelectionResponse
 */
export interface ModelSelectionResponse {
    /**
     * selected_model is the chosen model configuration.
     *
     * @generated from protobuf field: agency.model.v1.ModelConfig selected_model = 1
     */
    selectedModel?: ModelConfig;
    /**
     * fallback_models are alternative models in priority order.
     *
     * @generated from protobuf field: repeated agency.model.v1.ModelConfig fallback_models = 2
     */
    fallbackModels: ModelConfig[];
    /**
     * selection_reason explains why this model was chosen.
     *
     * @generated from protobuf field: string selection_reason = 3
     */
    selectionReason: string;
}
/**
 * ModelHealthCheck represents a model health check result.
 *
 * @generated from protobuf message agency.model.v1.ModelHealthCheck
 */
export interface ModelHealthCheck {
    /**
     * model_id is the checked model.
     *
     * @generated from protobuf field: string model_id = 1
     */
    modelId: string;
    /**
     * healthy indicates if the model is available.
     *
     * @generated from protobuf field: bool healthy = 2
     */
    healthy: boolean;
    /**
     * latency_ms is the health check response time.
     *
     * @generated from protobuf field: int32 latency_ms = 3
     */
    latencyMs: number;
    /**
     * checked_at is when the health check occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp checked_at = 4
     */
    checkedAt?: Timestamp;
    /**
     * error_message describes failures (if unhealthy).
     *
     * @generated from protobuf field: string error_message = 5
     */
    errorMessage: string;
    /**
     * consecutive_failures is the failure count since last success.
     *
     * @generated from protobuf field: int32 consecutive_failures = 6
     */
    consecutiveFailures: number;
}
/**
 * ModelFallbackChain defines the fallback chain for model failures.
 *
 * @generated from protobuf message agency.model.v1.ModelFallbackChain
 */
export interface ModelFallbackChain {
    /**
     * primary_model_id is the primary model to use.
     *
     * @generated from protobuf field: string primary_model_id = 1
     */
    primaryModelId: string;
    /**
     * secondary_model_id is the fallback if primary fails.
     *
     * @generated from protobuf field: string secondary_model_id = 2
     */
    secondaryModelId: string;
    /**
     * tertiary_model_id is the final fallback.
     *
     * @generated from protobuf field: string tertiary_model_id = 3
     */
    tertiaryModelId: string;
    /**
     * fallback_on_errors are error classes that trigger fallback.
     *
     * @generated from protobuf field: repeated string fallback_on_errors = 4
     */
    fallbackOnErrors: string[];
    /**
     * max_fallback_attempts is the maximum fallback chain depth.
     *
     * @generated from protobuf field: int32 max_fallback_attempts = 5
     */
    maxFallbackAttempts: number;
}
/**
 * ModelSelectionStrategy defines how models are selected for routing.
 *
 * @generated from protobuf message agency.model.v1.ModelSelectionStrategy
 */
export interface ModelSelectionStrategy {
    /**
     * strategy_type is the selection algorithm.
     *
     * @generated from protobuf field: agency.model.v1.SelectionStrategyType strategy_type = 1
     */
    strategyType: SelectionStrategyType;
    /**
     * cost_weight is the importance of cost (0.0-1.0).
     *
     * @generated from protobuf field: float cost_weight = 2
     */
    costWeight: number;
    /**
     * latency_weight is the importance of latency (0.0-1.0).
     *
     * @generated from protobuf field: float latency_weight = 3
     */
    latencyWeight: number;
    /**
     * capability_weight is the importance of capabilities (0.0-1.0).
     *
     * @generated from protobuf field: float capability_weight = 4
     */
    capabilityWeight: number;
    /**
     * required_capabilities are must-have features.
     *
     * @generated from protobuf field: repeated string required_capabilities = 5
     */
    requiredCapabilities: string[];
}
/**
 * ModelProvider identifies the LLM provider.
 *
 * @generated from protobuf enum agency.model.v1.ModelProvider
 */
export enum ModelProvider {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * OPENAI represents OpenAI models.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_OPENAI = 1;
     */
    OPENAI = 1,
    /**
     * ANTHROPIC represents Anthropic/Claude models.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_ANTHROPIC = 2;
     */
    ANTHROPIC = 2,
    /**
     * GOOGLE represents Google/Gemini models.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_GOOGLE = 3;
     */
    GOOGLE = 3,
    /**
     * MISTRAL represents Mistral AI models.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_MISTRAL = 4;
     */
    MISTRAL = 4,
    /**
     * COHERE represents Cohere models.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_COHERE = 5;
     */
    COHERE = 5,
    /**
     * LOCALAI represents self-hosted LocalAI.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_LOCALAI = 6;
     */
    LOCALAI = 6,
    /**
     * OLLAMA represents self-hosted Ollama.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_OLLAMA = 7;
     */
    OLLAMA = 7,
    /**
     * GROQ represents Groq-hosted models (OpenAI-compatible API).
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_GROQ = 8;
     */
    GROQ = 8,
    /**
     * CEREBRAS represents Cerebras-hosted models (OpenAI-compatible API).
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_CEREBRAS = 9;
     */
    CEREBRAS = 9,
    /**
     * SAIL represents Sail Research-hosted models (OpenAI-compatible API).
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_SAIL = 10;
     */
    SAIL = 10,
    /**
     * CUSTOM represents custom provider implementations.
     *
     * @generated from protobuf enum value: MODEL_PROVIDER_CUSTOM = 100;
     */
    CUSTOM = 100
}
/**
 * SelectionStrategyType defines model selection algorithms.
 *
 * @generated from protobuf enum agency.model.v1.SelectionStrategyType
 */
export enum SelectionStrategyType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * COST_OPTIMIZED prioritizes lowest cost models.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_COST_OPTIMIZED = 1;
     */
    COST_OPTIMIZED = 1,
    /**
     * LATENCY_OPTIMIZED prioritizes fastest models.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_LATENCY_OPTIMIZED = 2;
     */
    LATENCY_OPTIMIZED = 2,
    /**
     * CAPABILITY_OPTIMIZED prioritizes most capable models.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_CAPABILITY_OPTIMIZED = 3;
     */
    CAPABILITY_OPTIMIZED = 3,
    /**
     * BALANCED uses weighted scoring across all factors.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_BALANCED = 4;
     */
    BALANCED = 4,
    /**
     * ROUND_ROBIN cycles through available models.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_ROUND_ROBIN = 5;
     */
    ROUND_ROBIN = 5,
    /**
     * PRIORITY_BASED uses model priority field.
     *
     * @generated from protobuf enum value: SELECTION_STRATEGY_TYPE_PRIORITY_BASED = 6;
     */
    PRIORITY_BASED = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class ProviderCompat$Type extends MessageType<ProviderCompat> {
    constructor() {
        super("agency.model.v1.ProviderCompat", [
            { no: 1, name: "supports_thinking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "supports_tool_calls", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "supports_streaming", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "supports_vision", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "supports_audio", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "supports_video", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "max_tool_call_id_length", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 4096, gte: 0 } } } },
            { no: 8, name: "requires_tool_choice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "thinking_block_tag", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } },
            { no: 10, name: "supports_system_prompt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "requires_alternating_roles", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ProviderCompat>): ProviderCompat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.supportsThinking = false;
        message.supportsToolCalls = false;
        message.supportsStreaming = false;
        message.supportsVision = false;
        message.supportsAudio = false;
        message.supportsVideo = false;
        message.maxToolCallIdLength = 0;
        message.requiresToolChoice = false;
        message.thinkingBlockTag = "";
        message.supportsSystemPrompt = false;
        message.requiresAlternatingRoles = false;
        if (value !== undefined)
            reflectionMergePartial<ProviderCompat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProviderCompat): ProviderCompat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool supports_thinking */ 1:
                    message.supportsThinking = reader.bool();
                    break;
                case /* bool supports_tool_calls */ 2:
                    message.supportsToolCalls = reader.bool();
                    break;
                case /* bool supports_streaming */ 3:
                    message.supportsStreaming = reader.bool();
                    break;
                case /* bool supports_vision */ 4:
                    message.supportsVision = reader.bool();
                    break;
                case /* bool supports_audio */ 5:
                    message.supportsAudio = reader.bool();
                    break;
                case /* bool supports_video */ 6:
                    message.supportsVideo = reader.bool();
                    break;
                case /* int32 max_tool_call_id_length */ 7:
                    message.maxToolCallIdLength = reader.int32();
                    break;
                case /* bool requires_tool_choice */ 8:
                    message.requiresToolChoice = reader.bool();
                    break;
                case /* string thinking_block_tag */ 9:
                    message.thinkingBlockTag = reader.string();
                    break;
                case /* bool supports_system_prompt */ 10:
                    message.supportsSystemPrompt = reader.bool();
                    break;
                case /* bool requires_alternating_roles */ 11:
                    message.requiresAlternatingRoles = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProviderCompat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool supports_thinking = 1; */
        if (message.supportsThinking !== false)
            writer.tag(1, WireType.Varint).bool(message.supportsThinking);
        /* bool supports_tool_calls = 2; */
        if (message.supportsToolCalls !== false)
            writer.tag(2, WireType.Varint).bool(message.supportsToolCalls);
        /* bool supports_streaming = 3; */
        if (message.supportsStreaming !== false)
            writer.tag(3, WireType.Varint).bool(message.supportsStreaming);
        /* bool supports_vision = 4; */
        if (message.supportsVision !== false)
            writer.tag(4, WireType.Varint).bool(message.supportsVision);
        /* bool supports_audio = 5; */
        if (message.supportsAudio !== false)
            writer.tag(5, WireType.Varint).bool(message.supportsAudio);
        /* bool supports_video = 6; */
        if (message.supportsVideo !== false)
            writer.tag(6, WireType.Varint).bool(message.supportsVideo);
        /* int32 max_tool_call_id_length = 7; */
        if (message.maxToolCallIdLength !== 0)
            writer.tag(7, WireType.Varint).int32(message.maxToolCallIdLength);
        /* bool requires_tool_choice = 8; */
        if (message.requiresToolChoice !== false)
            writer.tag(8, WireType.Varint).bool(message.requiresToolChoice);
        /* string thinking_block_tag = 9; */
        if (message.thinkingBlockTag !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.thinkingBlockTag);
        /* bool supports_system_prompt = 10; */
        if (message.supportsSystemPrompt !== false)
            writer.tag(10, WireType.Varint).bool(message.supportsSystemPrompt);
        /* bool requires_alternating_roles = 11; */
        if (message.requiresAlternatingRoles !== false)
            writer.tag(11, WireType.Varint).bool(message.requiresAlternatingRoles);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ProviderCompat
 */
export const ProviderCompat = new ProviderCompat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProviderCapabilities$Type extends MessageType<ProviderCapabilities> {
    constructor() {
        super("agency.model.v1.ProviderCapabilities", [
            { no: 1, name: "max_context_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000000, gte: 0 } } } },
            { no: 2, name: "max_output_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000000, gte: 0 } } } },
            { no: 3, name: "max_tools_per_request", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 0 } } } },
            { no: 4, name: "supports_parallel_tool_calls", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "rate_limit_rpm", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000000, gte: 0 } } } },
            { no: 6, name: "rate_limit_tpm", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100000000, gte: 0 } } } },
            { no: 7, name: "cost_per_million_input_tokens", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { gte: 0 } } } },
            { no: 8, name: "cost_per_million_output_tokens", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { gte: 0 } } } },
            { no: 9, name: "default_temperature", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 2, gte: 0 } } } },
            { no: 10, name: "supports_json_mode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "supports_function_calling", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "supports_session_caching", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "supports_images", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "supports_tools", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "supports_streaming", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "supports_thinking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "max_images_per_request", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ProviderCapabilities>): ProviderCapabilities {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxContextTokens = 0;
        message.maxOutputTokens = 0;
        message.maxToolsPerRequest = 0;
        message.supportsParallelToolCalls = false;
        message.rateLimitRpm = 0;
        message.rateLimitTpm = 0;
        message.costPerMillionInputTokens = 0;
        message.costPerMillionOutputTokens = 0;
        message.defaultTemperature = 0;
        message.supportsJsonMode = false;
        message.supportsFunctionCalling = false;
        message.supportsSessionCaching = false;
        message.supportsImages = false;
        message.supportsTools = false;
        message.supportsStreaming = false;
        message.supportsThinking = false;
        message.maxImagesPerRequest = 0;
        if (value !== undefined)
            reflectionMergePartial<ProviderCapabilities>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProviderCapabilities): ProviderCapabilities {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 max_context_tokens */ 1:
                    message.maxContextTokens = reader.int32();
                    break;
                case /* int32 max_output_tokens */ 2:
                    message.maxOutputTokens = reader.int32();
                    break;
                case /* int32 max_tools_per_request */ 3:
                    message.maxToolsPerRequest = reader.int32();
                    break;
                case /* bool supports_parallel_tool_calls */ 4:
                    message.supportsParallelToolCalls = reader.bool();
                    break;
                case /* int32 rate_limit_rpm */ 5:
                    message.rateLimitRpm = reader.int32();
                    break;
                case /* int32 rate_limit_tpm */ 6:
                    message.rateLimitTpm = reader.int32();
                    break;
                case /* float cost_per_million_input_tokens */ 7:
                    message.costPerMillionInputTokens = reader.float();
                    break;
                case /* float cost_per_million_output_tokens */ 8:
                    message.costPerMillionOutputTokens = reader.float();
                    break;
                case /* float default_temperature */ 9:
                    message.defaultTemperature = reader.float();
                    break;
                case /* bool supports_json_mode */ 10:
                    message.supportsJsonMode = reader.bool();
                    break;
                case /* bool supports_function_calling */ 11:
                    message.supportsFunctionCalling = reader.bool();
                    break;
                case /* bool supports_session_caching */ 12:
                    message.supportsSessionCaching = reader.bool();
                    break;
                case /* bool supports_images */ 13:
                    message.supportsImages = reader.bool();
                    break;
                case /* bool supports_tools */ 14:
                    message.supportsTools = reader.bool();
                    break;
                case /* bool supports_streaming */ 15:
                    message.supportsStreaming = reader.bool();
                    break;
                case /* bool supports_thinking */ 16:
                    message.supportsThinking = reader.bool();
                    break;
                case /* int32 max_images_per_request */ 17:
                    message.maxImagesPerRequest = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProviderCapabilities, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 max_context_tokens = 1; */
        if (message.maxContextTokens !== 0)
            writer.tag(1, WireType.Varint).int32(message.maxContextTokens);
        /* int32 max_output_tokens = 2; */
        if (message.maxOutputTokens !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxOutputTokens);
        /* int32 max_tools_per_request = 3; */
        if (message.maxToolsPerRequest !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxToolsPerRequest);
        /* bool supports_parallel_tool_calls = 4; */
        if (message.supportsParallelToolCalls !== false)
            writer.tag(4, WireType.Varint).bool(message.supportsParallelToolCalls);
        /* int32 rate_limit_rpm = 5; */
        if (message.rateLimitRpm !== 0)
            writer.tag(5, WireType.Varint).int32(message.rateLimitRpm);
        /* int32 rate_limit_tpm = 6; */
        if (message.rateLimitTpm !== 0)
            writer.tag(6, WireType.Varint).int32(message.rateLimitTpm);
        /* float cost_per_million_input_tokens = 7; */
        if (message.costPerMillionInputTokens !== 0)
            writer.tag(7, WireType.Bit32).float(message.costPerMillionInputTokens);
        /* float cost_per_million_output_tokens = 8; */
        if (message.costPerMillionOutputTokens !== 0)
            writer.tag(8, WireType.Bit32).float(message.costPerMillionOutputTokens);
        /* float default_temperature = 9; */
        if (message.defaultTemperature !== 0)
            writer.tag(9, WireType.Bit32).float(message.defaultTemperature);
        /* bool supports_json_mode = 10; */
        if (message.supportsJsonMode !== false)
            writer.tag(10, WireType.Varint).bool(message.supportsJsonMode);
        /* bool supports_function_calling = 11; */
        if (message.supportsFunctionCalling !== false)
            writer.tag(11, WireType.Varint).bool(message.supportsFunctionCalling);
        /* bool supports_session_caching = 12; */
        if (message.supportsSessionCaching !== false)
            writer.tag(12, WireType.Varint).bool(message.supportsSessionCaching);
        /* bool supports_images = 13; */
        if (message.supportsImages !== false)
            writer.tag(13, WireType.Varint).bool(message.supportsImages);
        /* bool supports_tools = 14; */
        if (message.supportsTools !== false)
            writer.tag(14, WireType.Varint).bool(message.supportsTools);
        /* bool supports_streaming = 15; */
        if (message.supportsStreaming !== false)
            writer.tag(15, WireType.Varint).bool(message.supportsStreaming);
        /* bool supports_thinking = 16; */
        if (message.supportsThinking !== false)
            writer.tag(16, WireType.Varint).bool(message.supportsThinking);
        /* int32 max_images_per_request = 17; */
        if (message.maxImagesPerRequest !== 0)
            writer.tag(17, WireType.Varint).int32(message.maxImagesPerRequest);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ProviderCapabilities
 */
export const ProviderCapabilities = new ProviderCapabilities$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelConfig$Type extends MessageType<ModelConfig> {
    constructor() {
        super("agency.model.v1.ModelConfig", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_.-]*[a-z0-9]$" } } } },
            { no: 2, name: "provider", kind: "enum", T: () => ["agency.model.v1.ModelProvider", ModelProvider, "MODEL_PROVIDER_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "provider_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "compat", kind: "message", T: () => ProviderCompat, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "capabilities", kind: "message", T: () => ProviderCapabilities, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "endpoint_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 8, name: "api_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64" } } } },
            { no: 9, name: "default_params", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 10, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 11, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } },
            { no: 12, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "health_check_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 14, name: "timeout_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 604800, gte: 1 } } } },
            { no: 15, name: "retry_config", kind: "message", T: () => RetryConfig },
            { no: 16, name: "fallback_chain", kind: "message", T: () => ModelFallbackChain },
            { no: 17, name: "selection_strategy", kind: "message", T: () => ModelSelectionStrategy },
            { no: 19, name: "extra_body", kind: "message", T: () => Struct },
            { no: 20, name: "background_poll_interval", kind: "message", T: () => Duration, options: { "buf.validate.field": { duration: { gt: {} } } } }
        ]);
    }
    create(value?: PartialMessage<ModelConfig>): ModelConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.modelId = "";
        message.provider = 0;
        message.providerModelId = "";
        message.displayName = "";
        message.endpointUrl = "";
        message.apiVersion = "";
        message.defaultParams = {};
        message.tags = [];
        message.priority = 0;
        message.enabled = false;
        message.healthCheckUrl = "";
        message.timeoutSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial<ModelConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelConfig): ModelConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* agency.model.v1.ModelProvider provider */ 2:
                    message.provider = reader.int32();
                    break;
                case /* string provider_model_id */ 3:
                    message.providerModelId = reader.string();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* agency.model.v1.ProviderCompat compat */ 5:
                    message.compat = ProviderCompat.internalBinaryRead(reader, reader.uint32(), options, message.compat);
                    break;
                case /* agency.model.v1.ProviderCapabilities capabilities */ 6:
                    message.capabilities = ProviderCapabilities.internalBinaryRead(reader, reader.uint32(), options, message.capabilities);
                    break;
                case /* string endpoint_url */ 7:
                    message.endpointUrl = reader.string();
                    break;
                case /* string api_version */ 8:
                    message.apiVersion = reader.string();
                    break;
                case /* map<string, string> default_params */ 9:
                    this.binaryReadMap9(message.defaultParams, reader, options);
                    break;
                case /* repeated string tags */ 10:
                    message.tags.push(reader.string());
                    break;
                case /* int32 priority */ 11:
                    message.priority = reader.int32();
                    break;
                case /* bool enabled */ 12:
                    message.enabled = reader.bool();
                    break;
                case /* string health_check_url */ 13:
                    message.healthCheckUrl = reader.string();
                    break;
                case /* int32 timeout_seconds */ 14:
                    message.timeoutSeconds = reader.int32();
                    break;
                case /* agency.model.v1.RetryConfig retry_config */ 15:
                    message.retryConfig = RetryConfig.internalBinaryRead(reader, reader.uint32(), options, message.retryConfig);
                    break;
                case /* agency.model.v1.ModelFallbackChain fallback_chain */ 16:
                    message.fallbackChain = ModelFallbackChain.internalBinaryRead(reader, reader.uint32(), options, message.fallbackChain);
                    break;
                case /* agency.model.v1.ModelSelectionStrategy selection_strategy */ 17:
                    message.selectionStrategy = ModelSelectionStrategy.internalBinaryRead(reader, reader.uint32(), options, message.selectionStrategy);
                    break;
                case /* google.protobuf.Struct extra_body */ 19:
                    message.extraBody = Struct.internalBinaryRead(reader, reader.uint32(), options, message.extraBody);
                    break;
                case /* google.protobuf.Duration background_poll_interval */ 20:
                    message.backgroundPollInterval = Duration.internalBinaryRead(reader, reader.uint32(), options, message.backgroundPollInterval);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: ModelConfig["defaultParams"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ModelConfig["defaultParams"] | undefined, val: ModelConfig["defaultParams"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.model.v1.ModelConfig.default_params");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ModelConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* agency.model.v1.ModelProvider provider = 2; */
        if (message.provider !== 0)
            writer.tag(2, WireType.Varint).int32(message.provider);
        /* string provider_model_id = 3; */
        if (message.providerModelId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.providerModelId);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* agency.model.v1.ProviderCompat compat = 5; */
        if (message.compat)
            ProviderCompat.internalBinaryWrite(message.compat, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.model.v1.ProviderCapabilities capabilities = 6; */
        if (message.capabilities)
            ProviderCapabilities.internalBinaryWrite(message.capabilities, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string endpoint_url = 7; */
        if (message.endpointUrl !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.endpointUrl);
        /* string api_version = 8; */
        if (message.apiVersion !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.apiVersion);
        /* map<string, string> default_params = 9; */
        for (let k of globalThis.Object.keys(message.defaultParams))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.defaultParams[k]).join();
        /* repeated string tags = 10; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.tags[i]);
        /* int32 priority = 11; */
        if (message.priority !== 0)
            writer.tag(11, WireType.Varint).int32(message.priority);
        /* bool enabled = 12; */
        if (message.enabled !== false)
            writer.tag(12, WireType.Varint).bool(message.enabled);
        /* string health_check_url = 13; */
        if (message.healthCheckUrl !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.healthCheckUrl);
        /* int32 timeout_seconds = 14; */
        if (message.timeoutSeconds !== 0)
            writer.tag(14, WireType.Varint).int32(message.timeoutSeconds);
        /* agency.model.v1.RetryConfig retry_config = 15; */
        if (message.retryConfig)
            RetryConfig.internalBinaryWrite(message.retryConfig, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* agency.model.v1.ModelFallbackChain fallback_chain = 16; */
        if (message.fallbackChain)
            ModelFallbackChain.internalBinaryWrite(message.fallbackChain, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* agency.model.v1.ModelSelectionStrategy selection_strategy = 17; */
        if (message.selectionStrategy)
            ModelSelectionStrategy.internalBinaryWrite(message.selectionStrategy, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct extra_body = 19; */
        if (message.extraBody)
            Struct.internalBinaryWrite(message.extraBody, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration background_poll_interval = 20; */
        if (message.backgroundPollInterval)
            Duration.internalBinaryWrite(message.backgroundPollInterval, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ModelConfig
 */
export const ModelConfig = new ModelConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RetryConfig$Type extends MessageType<RetryConfig> {
    constructor() {
        super("agency.model.v1.RetryConfig", [
            { no: 1, name: "max_retries", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 0 } } } },
            { no: 2, name: "initial_backoff_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 60000, gte: 0 } } } },
            { no: 3, name: "max_backoff_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 300000, gte: 0 } } } },
            { no: 4, name: "backoff_multiplier", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 10, gte: 1 } } } },
            { no: 5, name: "retryable_status_codes", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { int32: { lte: 599, gte: 400 } } } } } }
        ]);
    }
    create(value?: PartialMessage<RetryConfig>): RetryConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxRetries = 0;
        message.initialBackoffMs = 0;
        message.maxBackoffMs = 0;
        message.backoffMultiplier = 0;
        message.retryableStatusCodes = [];
        if (value !== undefined)
            reflectionMergePartial<RetryConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RetryConfig): RetryConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 max_retries */ 1:
                    message.maxRetries = reader.int32();
                    break;
                case /* int32 initial_backoff_ms */ 2:
                    message.initialBackoffMs = reader.int32();
                    break;
                case /* int32 max_backoff_ms */ 3:
                    message.maxBackoffMs = reader.int32();
                    break;
                case /* float backoff_multiplier */ 4:
                    message.backoffMultiplier = reader.float();
                    break;
                case /* repeated int32 retryable_status_codes */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.retryableStatusCodes.push(reader.int32());
                    else
                        message.retryableStatusCodes.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RetryConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 max_retries = 1; */
        if (message.maxRetries !== 0)
            writer.tag(1, WireType.Varint).int32(message.maxRetries);
        /* int32 initial_backoff_ms = 2; */
        if (message.initialBackoffMs !== 0)
            writer.tag(2, WireType.Varint).int32(message.initialBackoffMs);
        /* int32 max_backoff_ms = 3; */
        if (message.maxBackoffMs !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxBackoffMs);
        /* float backoff_multiplier = 4; */
        if (message.backoffMultiplier !== 0)
            writer.tag(4, WireType.Bit32).float(message.backoffMultiplier);
        /* repeated int32 retryable_status_codes = 5; */
        if (message.retryableStatusCodes.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.retryableStatusCodes.length; i++)
                writer.int32(message.retryableStatusCodes[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.RetryConfig
 */
export const RetryConfig = new RetryConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelSelectionRequest$Type extends MessageType<ModelSelectionRequest> {
    constructor() {
        super("agency.model.v1.ModelSelectionRequest", [
            { no: 1, name: "required_capabilities", kind: "message", T: () => ProviderCompat },
            { no: 2, name: "preferred_providers", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["agency.model.v1.ModelProvider", ModelProvider, "MODEL_PROVIDER_"], options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 3, name: "min_context_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "max_cost_per_million_tokens", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { gte: 0 } } } },
            { no: 5, name: "required_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 6, name: "exclude_model_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ModelSelectionRequest>): ModelSelectionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.preferredProviders = [];
        message.minContextTokens = 0;
        message.maxCostPerMillionTokens = 0;
        message.requiredTags = [];
        message.excludeModelIds = [];
        if (value !== undefined)
            reflectionMergePartial<ModelSelectionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelSelectionRequest): ModelSelectionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.model.v1.ProviderCompat required_capabilities */ 1:
                    message.requiredCapabilities = ProviderCompat.internalBinaryRead(reader, reader.uint32(), options, message.requiredCapabilities);
                    break;
                case /* repeated agency.model.v1.ModelProvider preferred_providers */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.preferredProviders.push(reader.int32());
                    else
                        message.preferredProviders.push(reader.int32());
                    break;
                case /* int32 min_context_tokens */ 3:
                    message.minContextTokens = reader.int32();
                    break;
                case /* float max_cost_per_million_tokens */ 4:
                    message.maxCostPerMillionTokens = reader.float();
                    break;
                case /* repeated string required_tags */ 5:
                    message.requiredTags.push(reader.string());
                    break;
                case /* repeated string exclude_model_ids */ 6:
                    message.excludeModelIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelSelectionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.model.v1.ProviderCompat required_capabilities = 1; */
        if (message.requiredCapabilities)
            ProviderCompat.internalBinaryWrite(message.requiredCapabilities, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.model.v1.ModelProvider preferred_providers = 2; */
        if (message.preferredProviders.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.preferredProviders.length; i++)
                writer.int32(message.preferredProviders[i]);
            writer.join();
        }
        /* int32 min_context_tokens = 3; */
        if (message.minContextTokens !== 0)
            writer.tag(3, WireType.Varint).int32(message.minContextTokens);
        /* float max_cost_per_million_tokens = 4; */
        if (message.maxCostPerMillionTokens !== 0)
            writer.tag(4, WireType.Bit32).float(message.maxCostPerMillionTokens);
        /* repeated string required_tags = 5; */
        for (let i = 0; i < message.requiredTags.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.requiredTags[i]);
        /* repeated string exclude_model_ids = 6; */
        for (let i = 0; i < message.excludeModelIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.excludeModelIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ModelSelectionRequest
 */
export const ModelSelectionRequest = new ModelSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelSelectionResponse$Type extends MessageType<ModelSelectionResponse> {
    constructor() {
        super("agency.model.v1.ModelSelectionResponse", [
            { no: 1, name: "selected_model", kind: "message", T: () => ModelConfig, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "fallback_models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ModelConfig, options: { "buf.validate.field": { repeated: { maxItems: "10" } } } },
            { no: 3, name: "selection_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ModelSelectionResponse>): ModelSelectionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fallbackModels = [];
        message.selectionReason = "";
        if (value !== undefined)
            reflectionMergePartial<ModelSelectionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelSelectionResponse): ModelSelectionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.model.v1.ModelConfig selected_model */ 1:
                    message.selectedModel = ModelConfig.internalBinaryRead(reader, reader.uint32(), options, message.selectedModel);
                    break;
                case /* repeated agency.model.v1.ModelConfig fallback_models */ 2:
                    message.fallbackModels.push(ModelConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string selection_reason */ 3:
                    message.selectionReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelSelectionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.model.v1.ModelConfig selected_model = 1; */
        if (message.selectedModel)
            ModelConfig.internalBinaryWrite(message.selectedModel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.model.v1.ModelConfig fallback_models = 2; */
        for (let i = 0; i < message.fallbackModels.length; i++)
            ModelConfig.internalBinaryWrite(message.fallbackModels[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string selection_reason = 3; */
        if (message.selectionReason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.selectionReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ModelSelectionResponse
 */
export const ModelSelectionResponse = new ModelSelectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelHealthCheck$Type extends MessageType<ModelHealthCheck> {
    constructor() {
        super("agency.model.v1.ModelHealthCheck", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "healthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "latency_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "checked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 6, name: "consecutive_failures", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ModelHealthCheck>): ModelHealthCheck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.modelId = "";
        message.healthy = false;
        message.latencyMs = 0;
        message.errorMessage = "";
        message.consecutiveFailures = 0;
        if (value !== undefined)
            reflectionMergePartial<ModelHealthCheck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelHealthCheck): ModelHealthCheck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* bool healthy */ 2:
                    message.healthy = reader.bool();
                    break;
                case /* int32 latency_ms */ 3:
                    message.latencyMs = reader.int32();
                    break;
                case /* google.protobuf.Timestamp checked_at */ 4:
                    message.checkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.checkedAt);
                    break;
                case /* string error_message */ 5:
                    message.errorMessage = reader.string();
                    break;
                case /* int32 consecutive_failures */ 6:
                    message.consecutiveFailures = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelHealthCheck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* bool healthy = 2; */
        if (message.healthy !== false)
            writer.tag(2, WireType.Varint).bool(message.healthy);
        /* int32 latency_ms = 3; */
        if (message.latencyMs !== 0)
            writer.tag(3, WireType.Varint).int32(message.latencyMs);
        /* google.protobuf.Timestamp checked_at = 4; */
        if (message.checkedAt)
            Timestamp.internalBinaryWrite(message.checkedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        /* int32 consecutive_failures = 6; */
        if (message.consecutiveFailures !== 0)
            writer.tag(6, WireType.Varint).int32(message.consecutiveFailures);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ModelHealthCheck
 */
export const ModelHealthCheck = new ModelHealthCheck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelFallbackChain$Type extends MessageType<ModelFallbackChain> {
    constructor() {
        super("agency.model.v1.ModelFallbackChain", [
            { no: 1, name: "primary_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_.-]*[a-z0-9]$" } } } },
            { no: 2, name: "secondary_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_.-]*[a-z0-9])?$" } } } },
            { no: 3, name: "tertiary_model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_.-]*[a-z0-9])?$" } } } },
            { no: 4, name: "fallback_on_errors", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64", pattern: "^(RATE_LIMIT|TIMEOUT|UNAVAILABLE|CONTEXT_LENGTH|AUTHENTICATION|INTERNAL_ERROR)$" } } } } } },
            { no: 5, name: "max_fallback_attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<ModelFallbackChain>): ModelFallbackChain {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.primaryModelId = "";
        message.secondaryModelId = "";
        message.tertiaryModelId = "";
        message.fallbackOnErrors = [];
        message.maxFallbackAttempts = 0;
        if (value !== undefined)
            reflectionMergePartial<ModelFallbackChain>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelFallbackChain): ModelFallbackChain {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string primary_model_id */ 1:
                    message.primaryModelId = reader.string();
                    break;
                case /* string secondary_model_id */ 2:
                    message.secondaryModelId = reader.string();
                    break;
                case /* string tertiary_model_id */ 3:
                    message.tertiaryModelId = reader.string();
                    break;
                case /* repeated string fallback_on_errors */ 4:
                    message.fallbackOnErrors.push(reader.string());
                    break;
                case /* int32 max_fallback_attempts */ 5:
                    message.maxFallbackAttempts = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelFallbackChain, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string primary_model_id = 1; */
        if (message.primaryModelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.primaryModelId);
        /* string secondary_model_id = 2; */
        if (message.secondaryModelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.secondaryModelId);
        /* string tertiary_model_id = 3; */
        if (message.tertiaryModelId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tertiaryModelId);
        /* repeated string fallback_on_errors = 4; */
        for (let i = 0; i < message.fallbackOnErrors.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fallbackOnErrors[i]);
        /* int32 max_fallback_attempts = 5; */
        if (message.maxFallbackAttempts !== 0)
            writer.tag(5, WireType.Varint).int32(message.maxFallbackAttempts);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ModelFallbackChain
 */
export const ModelFallbackChain = new ModelFallbackChain$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModelSelectionStrategy$Type extends MessageType<ModelSelectionStrategy> {
    constructor() {
        super("agency.model.v1.ModelSelectionStrategy", [
            { no: 1, name: "strategy_type", kind: "enum", T: () => ["agency.model.v1.SelectionStrategyType", SelectionStrategyType, "SELECTION_STRATEGY_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "cost_weight", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 3, name: "latency_weight", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 4, name: "capability_weight", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 5, name: "required_capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ModelSelectionStrategy>): ModelSelectionStrategy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.strategyType = 0;
        message.costWeight = 0;
        message.latencyWeight = 0;
        message.capabilityWeight = 0;
        message.requiredCapabilities = [];
        if (value !== undefined)
            reflectionMergePartial<ModelSelectionStrategy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ModelSelectionStrategy): ModelSelectionStrategy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.model.v1.SelectionStrategyType strategy_type */ 1:
                    message.strategyType = reader.int32();
                    break;
                case /* float cost_weight */ 2:
                    message.costWeight = reader.float();
                    break;
                case /* float latency_weight */ 3:
                    message.latencyWeight = reader.float();
                    break;
                case /* float capability_weight */ 4:
                    message.capabilityWeight = reader.float();
                    break;
                case /* repeated string required_capabilities */ 5:
                    message.requiredCapabilities.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ModelSelectionStrategy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.model.v1.SelectionStrategyType strategy_type = 1; */
        if (message.strategyType !== 0)
            writer.tag(1, WireType.Varint).int32(message.strategyType);
        /* float cost_weight = 2; */
        if (message.costWeight !== 0)
            writer.tag(2, WireType.Bit32).float(message.costWeight);
        /* float latency_weight = 3; */
        if (message.latencyWeight !== 0)
            writer.tag(3, WireType.Bit32).float(message.latencyWeight);
        /* float capability_weight = 4; */
        if (message.capabilityWeight !== 0)
            writer.tag(4, WireType.Bit32).float(message.capabilityWeight);
        /* repeated string required_capabilities = 5; */
        for (let i = 0; i < message.requiredCapabilities.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.requiredCapabilities[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.model.v1.ModelSelectionStrategy
 */
export const ModelSelectionStrategy = new ModelSelectionStrategy$Type();
